/* MGN · encuadre uniforme de fotos de producto.
   No modifica los archivos: mide en una miniatura cuánto margen blanco o transparente
   tiene cada foto y escala su presentación para que todos los envases ocupen
   un tamaño aparente parecido dentro de su recuadro (object-fit: contain, sin recortes). */
(function () {
  'use strict';
  if (window.__mgnEncuadre) return;
  window.__mgnEncuadre = true;

  var OBJETIVO = 0.86;
  var ESCALA_MAX = 1.9;
  var SELECTOR = [
    'product-card img.product-media__image',
    '.mgn-fit img'
  ].join(',');
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('mgn-encuadre') || '{}'); } catch (e) { cache = {}; }
  var guardar = function () { try { sessionStorage.setItem('mgn-encuadre', JSON.stringify(cache)); } catch (e) {} };

  function miniatura(src) {
    try {
      var u = new URL(src, location.href);
      if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) return null;
      u.searchParams.set('width', '96');
      u.searchParams.delete('height');
      u.searchParams.delete('crop');
      return u.href;
    } catch (e) { return null; }
  }
  function clave(src) { return src.split('?')[0]; }

  function medir(url) {
    return new Promise(function (ok) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          if (!w || !h) return ok(null);
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0);
          var d = x.getImageData(0, 0, w, h).data;
          var x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) {
            for (var X = 0; X < w; X++) {
              var i = (y * w + X) * 4;
              if (d[i + 3] < 24) continue;
              if (d[i] > 238 && d[i + 1] > 238 && d[i + 2] > 238) continue;
              if (X < x0) x0 = X; if (X > x1) x1 = X;
              if (y < y0) y0 = y; if (y > y1) y1 = y;
            }
          }
          if (x1 < 0) return ok(null);
          ok([x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h]);
        } catch (e) { ok(null); }
      };
      im.onerror = function () { ok(null); };
      im.src = url;
    });
  }

  function aplicar(img, b) {
    if (!b) return;
    var cs = getComputedStyle(img);
    var W = img.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    var H = img.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!W || !H || !nw || !nh) return;
    var r = nw / nh;
    var dW = Math.min(W, H * r), dH = dW / r;
    var cw = (b[2] - b[0]) * dW, ch = (b[3] - b[1]) * dH;
    if (cw < 4 || ch < 4) return;
    var s = Math.min(OBJETIVO * W / cw, OBJETIVO * H / ch, ESCALA_MAX);
    if (s < 1.03) { img.style.transform = ''; return; }
    var tx = (0.5 - (b[0] + b[2]) / 2) * dW;
    var ty = (0.5 - (b[1] + b[3]) / 2) * dH;
    img.style.objectFit = 'contain';
    img.style.transformOrigin = '50% 50%';
    img.style.transform = 'scale(' + s.toFixed(3) + ') translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px)';
    if (img.parentElement) img.parentElement.style.overflow = 'hidden';
  }

  function procesar(img) {
    var src = img.currentSrc || img.src;
    if (!src) return;
    var k = clave(src);
    if (img.dataset.mgnFit === k) return;
    img.dataset.mgnFit = k;
    var listo = function () {
      if (cache[k] !== undefined) return aplicar(img, cache[k]);
      var m = miniatura(src);
      if (!m) return;
      medir(m).then(function (b) { cache[k] = b; guardar(); aplicar(img, b); });
    };
    if (img.complete && img.naturalWidth) listo(); else img.addEventListener('load', listo, { once: true });
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); procesar(e.target); } });
  }, { rootMargin: '800px 0px' }) : null;

  function buscar(raiz) {
    (raiz || document).querySelectorAll(SELECTOR).forEach(function (img) {
      if (img.dataset.mgnObs) return;
      img.dataset.mgnObs = '1';
      if (io) io.observe(img); else procesar(img);
    });
  }

  function iniciar() {
    buscar();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].addedNodes.length) { buscar(); return; }
        if (ms[i].type === 'attributes' && ms[i].target.matches && ms[i].target.matches(SELECTOR)) {
          ms[i].target.dataset.mgnFit = ''; procesar(ms[i].target);
        }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        document.querySelectorAll(SELECTOR).forEach(function (img) {
          var k = img.dataset.mgnFit; if (k && cache[k] !== undefined) aplicar(img, cache[k]);
        });
      }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();